import JSEncrypt from 'jsencrypt'
import {
  tokenName,
  refreshGapTime,
  storage,
  tokenTableName,
  recordRoute,
} from '@/config'
import { message } from 'ant-design-vue'
import store from '@/store'
import cookie from 'js-cookie'
import { refresh } from '@/api/user'
import { router } from '@/main'
// import {debounce} from 'lodash'

/*
 * @description RSA加密
 *长文本先按100长度截取，再分次加密
 *返回多个加密字符串由逗号分隔
 * @param 原数据
 * @param 公钥
 */
export function encrypt(text, publicKey) {
  if (!text || !publicKey) throw new Error('RSA加密请传入原文本和公钥')
  if (text.constructor !== String) text = JSON.stringify(text)
  const crypt = new JSEncrypt()
  crypt.setKey(publicKey)
  if (text.length < 100) {
    return crypt.encrypt(text)
  }
  let i = 0
  const arr = []
  while (i * 100 < text.length) {
    arr[i] = crypt.encrypt(text.substr(i * 100, 100))
    i++
  }
  return arr.toString()
}

/*
 * @description 检查token剩余有效时间
 *如果剩余时间小于约定时间，就刷新token
 *如果剩余时间为负数，就退出登录
 */
export function checkRemaining() {
  const exp = localStorage.getItem('exp')
  const now = Math.floor(new Date().getTime() / 1000)

  //当前时间距离到期时间
  const duration = exp - now

  //已经过了有效时间，退出登录
  if (duration <= 0) {
    logout()
    return false
  }

  //距离到期时间小于约定值，刷新token
  else if (duration <= refreshGapTime) {
    refreshToken()
  }

  //距离到期时间大于约定值，无事发生
  return true
}

//刷新token
async function refreshToken() {
  const res = await refresh()
  if (res.success) {
    setAccessToken(res.data[tokenName])
    localStorage.setItem('exp', res.data.exp)
  }
}

let timer
const debounceMsg = (msg) => {
  clearTimeout(timer)
  timer = setTimeout(() => message.warn(msg), 200)
}
/*
 * @description 退出登录
 *删除token、vuex用户数据、跳转登录页
 *@param isMsg 是否弹出提示，默认是
 *@param msg 提示内容
 */
export function logout(isMsg = true, msg = '登录已过期，请重新登录') {
  store.dispatch('user/logout')
  store.dispatch('user/resetAll').catch(() => {})
  removeAccessToken()
  removeLocalRoutes()
  if (location.pathname !== '/login') {
    if (isMsg) debounceMsg(msg)
    const nowUrl = window.location.pathname
    router.replace('/login' + recordRoute ? '?redirect=' + nowUrl : '')
  }
}

/**
 * @description 获取accessToken
 * @returns {string|ActiveX.IXMLDOMNode|Promise<any>|any|IDBRequest<any>|MediaKeyStatus|FormDataEntryValue|Function|Promise<Credential | null>}
 */
export function getAccessToken() {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.getItem(tokenTableName)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.getItem(tokenTableName)
    } else if ('cookie' === storage) {
      return cookie.get(tokenTableName)
    } else {
      return localStorage.getItem(tokenTableName)
    }
  } else {
    return localStorage.getItem(tokenTableName)
  }
}

/**
 * @description 存储accessToken
 * @param accessToken
 * @returns {void|*}
 */
export function setAccessToken(accessToken) {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.setItem(tokenTableName, accessToken)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.setItem(tokenTableName, accessToken)
    } else if ('cookie' === storage) {
      return cookie.set(tokenTableName, accessToken)
    } else {
      return localStorage.setItem(tokenTableName, accessToken)
    }
  } else {
    return localStorage.setItem(tokenTableName, accessToken)
  }
}

/**
 * @description 移除accessToken
 * @returns {void|Promise<void>}
 */
export function removeAccessToken() {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.removeItem(tokenTableName)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.clear()
    } else if ('cookie' === storage) {
      return cookie.remove(tokenTableName)
    } else {
      return localStorage.removeItem(tokenTableName)
    }
  } else {
    return localStorage.removeItem(tokenTableName)
  }
}

const localRoutesName = 'vrs_routes'

export function setLocalRoutes(routes) {
  window.localStorage.setItem(localRoutesName, JSON.stringify(routes))
}
export function getLocalRoutes() {
  return JSON.parse(window.localStorage.getItem(localRoutesName))
}
export function removeLocalRoutes() {
  return window.localStorage.removeItem(localRoutesName)
}

export function hasRole(value) {
  if (store.getters['acl/admin']) return true
  if (value instanceof Array && value.length > 0)
    return can(store.getters['acl/role'], {
      role: value,
      mode: 'oneOf',
    })
  let mode = 'oneOf'
  if (Object.prototype.hasOwnProperty.call(value, 'mode')) mode = value['mode']
  let result = true
  if (Object.prototype.hasOwnProperty.call(value, 'role'))
    result =
      result && can(store.getters['acl/role'], { role: value['role'], mode })
  if (result && Object.prototype.hasOwnProperty.call(value, 'ability'))
    result =
      result &&
      can(store.getters['acl/ability'], {
        role: value['ability'],
        mode,
      })
  return result
}

export function can(roleOrAbility, value) {
  let hasRole = false
  if (
    value instanceof Object &&
    Object.prototype.hasOwnProperty.call(value, 'role') &&
    Object.prototype.hasOwnProperty.call(value, 'mode')
  ) {
    const { role, mode } = value
    if (mode === 'allOf') {
      hasRole = role.every((item) => {
        return roleOrAbility.includes(item)
      })
    }
    if (mode === 'oneOf') {
      hasRole = role.some((item) => {
        return roleOrAbility.includes(item)
      })
    }
    if (mode === 'except') {
      hasRole = !role.some((item) => {
        return roleOrAbility.includes(item)
      })
    }
  }
  return hasRole
}
